/** Maximum note length — mirrors firestore.rules `noteTextSizeValid`. */
export const MAX_PRACTITIONER_NOTE_LENGTH = 10000;

export interface PractitionerNoteRecord {
  id: string;
  text: string;
  createdByUid: string;
  createdByEmail?: string;
  createdByName?: string;
  createdAt: string;
  updatedAt?: string;
}
